import React from 'react'
import { OptionImage } from '@jarvis.oddle/core/molecules/ProductDetailsModal'
import { useAppContext } from 'src/containers/AppContext'
import useCustomisation from 'src/hooks/useCustomisation'

interface OptionThumbnailProps {
  variant: {
    imageFullUrls: string[]
    imageUrls: string[]
    variantName: string
  }
}

const OptionThumbnail = ({ variant }: OptionThumbnailProps): JSX.Element => {
  const { getSectionFromId } = useCustomisation()
  const { settings = {} } = getSectionFromId('productDetail') || {}

  const { getProductImagePath } = useAppContext()
  const { showOptionImage, showDefaultImage } = settings
  const optionImage = getProductImagePath(
    variant.imageFullUrls?.[0] || variant.imageUrls?.[0],
    showDefaultImage,
    {
      shouldCache: true,
      containerWidth: 80,
      containerHeight: 80
    }
  )
  return showOptionImage && optionImage ? (
    <OptionImage alt={variant.variantName} src={optionImage} />
  ) : null
}

export default OptionThumbnail
